import { jwtDecode } from "jwt-decode"

export function isTokenValid(token: string): boolean {
	const decodedToken = jwtDecode(token)

	// Proceed, if the token expires in the future
	return (!!decodedToken.exp && decodedToken.exp > (new Date).getTime() / 1000)
}
